import { renderInlineCssVars, useDesignTokens } from '../../../../theme';
import { postfixTestId } from '../../../../util/testId';
import { useDensity } from '../../../Density';
import { Popover } from '../../../Popover';
import { Text } from '../../../Text';
import cn from './MessagePopover.css.json';
import './MessagePopover.css';

// as per UX, the default message width should be this
import { jsx as _jsx } from "react/jsx-runtime";
const defaultMessageWidth = 160;
export const calculatePopoverWidth = (assignedWidth, inputContainerWidth, messageContainerWidth) => {
  if (!assignedWidth) {
    assignedWidth = Math.max(Math.min(inputContainerWidth, messageContainerWidth), defaultMessageWidth).toString();
  }
  return assignedWidth;
};
const DisplayMessage = props => {
  const dt = useDesignTokens();
  const {
    density
  } = useDensity();
  const tokens = {
    ...renderInlineCssVars(getThemeTokens(dt, density, props.status), 'message-popover')
  };
  const inputWidth = props.referenceElementRef?.current?.getBoundingClientRect().width ?? 0;
  const inputMaxWidth = Math.max(inputWidth, defaultMessageWidth).toString();
  const popoverAnimation = {
    closed: {
      opacity: 0
    },
    open: {
      opacity: 1,
      x: 0,
      y: 2,
      // default spacing of 0.125rem === 2px
      transition: {
        opacity: 1,
        type: 'spring',
        stiffness: 1130,
        dampness: 30,
        mass: 1,
        duration: 0.3,
        ease: [0, 0.5, 0.2, 1]
      }
    },
    exit: {
      opacity: 0,
      x: 0,
      y: 0,
      transition: {
        type: 'tween',
        duration: 0.3,
        ease: [0.5, 0, 0.8, 1]
      }
    }
  };
  return /*#__PURE__*/_jsx(Popover, {
    animation: {
      variants: popoverAnimation,
      initial: 'closed',
      animate: 'open',
      exit: 'exit'
    }
    // When we use this prop, the component is properly unmounted which triggers the proper exit animation.
    ,
    isOpen: props.isOpen,
    referenceElementRef: props.referenceElementRef,
    hideArrow: true,
    className: cn.content,
    placement: "bottom-start",
    focusLockProps: {
      disabled: true
    },
    style: {
      ...tokens,
      width: 'auto',
      maxWidth: props.maxWidth ?? `${inputMaxWidth}px`,
      minWidth: props.minWidth
    },
    testId: props.testId,
    hideOnRefHidden: props.hideOnRefHidden,
    onClose: props.onClose,
    children: /*#__PURE__*/_jsx(Text, {
      className: cn.messageText,
      testId: postfixTestId(props.testId, 'messageContainer'),
      children: props.message
    })
  });
};
export const MessagePopover = props => {
  return props.message ? /*#__PURE__*/_jsx(DisplayMessage, {
    ...props
  }) : null;
};
const getThemeTokens = (dt, density, status) => {
  if (dt.enableNovaTokens) {
    return {
      bd: dt.themeVariant === 'high-contrast' ? `1px solid ${dt.tokens['color-container-border-4']}` : 'none',
      bg: dt.tokens['color-container-background-0'],
      fg: dt.tokens['color-body-text'],
      'pd-squish-s': `${dt.tokens['space-base-xs']} ${dt.tokens['space-base-s']}`,
      'font-size': density === 'high' ? dt.tokens['font-size-body-text-s'] : dt.tokens['font-size-body-text-m']
    };
  } else {
    // legacy tokens
    return {
      bd: `1px solid ${dt.stateStatus[status].bd}`,
      bg: dt.stateStatus[status].bg,
      fg: dt.stateStatus[status].fg,
      'pd-squish-s': `${dt.tokens['space-base-xs']} ${dt.tokens['space-base-s']}`,
      'font-size': dt.reportTokens.font.size.xs
    };
  }
};
//# sourceMappingURL=MessagePopover.js.map